import React from 'react';
import {
  Flex,
  Heading,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Icon,
  Text,
  Box,
  useColorMode,
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  VStack,
} from '@chakra-ui/react';
import {
  AiOutlineLogout,
  AiOutlineCalendar,
  AiOutlineSun,
  AiOutlineMoon,
  AiOutlineBell,
  AiOutlineClockCircle,
} from 'react-icons/ai';
import { useAuth } from '../../hooks/auth';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const { signOut, user } = useAuth();
  const { colorMode, toggleColorMode } = useColorMode();
  const navigate = useNavigate();

  const displayName = user?.name || user?.email || 'Usuário';
  const userEmail = user?.email || '';
  const userInitial = displayName.charAt(0).toUpperCase();

  const iconBtnStyle = {
    variant: 'ghost',
    fontSize: '20px',
    color: 'textSecondary',
    borderRadius: 'lg',
    _hover: { color: 'secondary', bg: 'surfaceHover' },
  };

  return (
    <Flex direction="column" w="100%">
      <Flex
        as="header"
        h="20"
        alignItems="center"
        justifyContent="space-between"
        px={8}
        bg="surface"
        borderBottomWidth="1px"
        borderColor="borderPrimary"
        transition="all 0.2s"
      >
        <Heading
          as="h1"
          size="md"
          color="textPrimary"
          fontWeight="900"
          cursor="pointer"
          onClick={() => navigate('/')}
        >
          <Flex align="center" gap={2}>
            <Icon as={AiOutlineCalendar} color="secondary" />
            <Text>Agenda</Text>
          </Flex>
        </Heading>

        <Flex align="center" gap={3}>
          <IconButton
            aria-label="Alternar tema"
            icon={colorMode === 'dark' ? <AiOutlineSun /> : <AiOutlineMoon />}
            onClick={toggleColorMode}
            {...iconBtnStyle}
          />

          <Popover placement="bottom-end">
            <PopoverTrigger>
              <Box position="relative" display="inline-block">
                <IconButton
                  aria-label="Notificações"
                  icon={<AiOutlineBell />}
                  {...iconBtnStyle}
                />
              </Box>
            </PopoverTrigger>
            <PopoverContent
              bg="surface"
              borderColor="borderPrimary"
              color="textPrimary"
              w="320px"
              boxShadow="0 12px 34px rgba(0,0,0,0.22)"
              borderRadius="xl"
              overflow="hidden"
              _focus={{ outline: 'none', boxShadow: '0 12px 34px rgba(0,0,0,0.22)' }}
            >
              <PopoverArrow bg="surface" borderColor="borderPrimary" />
              <PopoverHeader borderBottom="1px solid" borderColor="borderPrimary" px={4} py={3}>
                <Text fontWeight="800" fontSize="sm">Notificações</Text>
              </PopoverHeader>
              <PopoverBody p={0}>
                <VStack spacing={2} py={10} px={5}>
                  <Flex w="44px" h="44px" borderRadius="full" bg="secondarySubtle" color="secondary" align="center" justify="center">
                    <Icon as={AiOutlineClockCircle} boxSize="22px" />
                  </Flex>
                  <Text color="textPrimary" fontSize="sm" fontWeight="800">Em breve</Text>
                  <Text color="textMuted" fontSize="xs" textAlign="center">
                    As notificações do Schedule ainda não estão ativas.
                  </Text>
                </VStack>
              </PopoverBody>
            </PopoverContent>
          </Popover>

          {user && (
            <Menu>
              <MenuButton
                as={Box}
                cursor="pointer"
                w="32px"
                h="32px"
                borderRadius="full"
                bg="secondary"
                display="grid"
                placeItems="center"
                _focus={{
                  boxShadow: '0 0 0 2px var(--chakra-colors-secondary)',
                  border: 'none',
                  outline: 'none'
                }}
              >
                <Text color="primary" fontWeight="bold" fontSize="md" lineHeight="1">
                  {userInitial}
                </Text>
              </MenuButton>

              <MenuList bg="surface" borderColor="borderPrimary" p={1} zIndex={2000}>
                <Box px={3} py={2} mb={2} borderBottom="1px solid" borderColor="borderPrimary">
                  <Text fontWeight="bold" color="textPrimary">{displayName}</Text>
                  <Text fontSize="xs" color="textMuted">{userEmail}</Text>
                </Box>
                <MenuDivider borderColor="borderPrimary" />
                <MenuItem
                  icon={<Icon as={AiOutlineLogout} w={4} h={4} />}
                  onClick={signOut}
                  bg="transparent"
                  color="danger"
                  _hover={{ bg: 'surfaceHover', color: 'danger' }}
                >
                  Sair
                </MenuItem>
              </MenuList>
            </Menu>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Header;
